export const fontConfig = {
  families: ['Inter:300,400,500,600,700,800', 'Pridi:300,400,500,600,700', 'Suwannaphum:300,400,700,900'],
  display: 'swap',
  api: 'https://fonts.googleapis.com',
  cssApi: 'https://fonts.gstatic.com',
};
